import React from "react";
import "../../App.css";
import "../../assets/style/LessonTypes.css";
import { weekDayMap } from "../../consts";
import { getLessonTypeStyle } from "../../utils/colorUtils";
import { useAuthStore } from "../../store";
import BatteryIndicator from "./BatteryIndicator";
import { Event as EventIcon } from "@mui/icons-material";

const SingleHour = ({
  hour,
  handleOpenSignUpModal,
  setValues,
  values,
  setLessonData,
}) => {
  const { isAdmin } = useAuthStore((state) => ({
    isAdmin: state.isAdmin,
  }));

  const timeSlots = [];
  const startDay = 0;
  const endDay = 7;

  const addLeadingZeros = (num) => String(num).padStart(2, "0");

  const isLessonInPast = (lesson) => {
    const currentTime = new Date();
    const lessonStartTime = new Date(
      lesson.start.year,
      lesson.start.month - 1,
      lesson.start.day,
      lesson.start.hour,
      lesson.start.minute,
      0
    );
    return lessonStartTime <= currentTime;
  };

  for (let i = startDay; i < endDay; i++) {
    if (!hour) {
      timeSlots.push(<td key={`empty-${i}`} className="bg-light-gray" />);
      continue;
    }

    const lessonsInSameHour = hour.filter(
      (lesson) => weekDayMap[i] === lesson.week_day
    );

    if (lessonsInSameHour.length > 0) {
      const lessonGroup = lessonsInSameHour.map((lesson) => {
        const start = `${addLeadingZeros(lesson.start.hour)}:${addLeadingZeros(
          lesson.start.minute
        )}`;
        const end = `${addLeadingZeros(lesson.end.hour)}:${addLeadingZeros(
          lesson.end.minute
        )}`;

        // Safety check: ensure current_people and max_people are valid numbers
        const currentPeople = Number(lesson.current_people) || 0;
        const maxPeople = Number(lesson.lesson_type.max_people) || 999;
        const isFull = currentPeople >= maxPeople;
        const isPast = !isAdmin && isLessonInPast(lesson);
        const isSignUpDisabled = lesson.sign_up_disabled;
        const isEventLesson = !!lesson.event_id;

        const eventColor = lesson.event_color || "#ff9800";
        
        return (
          <div 
            key={lesson.lesson_id} 
            className={`lesson-block ${isEventLesson ? "event-lesson" : ""}`}
            style={isEventLesson ? { 
              "--event-color": eventColor,
              borderColor: eventColor 
            } : undefined}
          >
            {/* Event indicator */}
            {isEventLesson && (
              <div 
                className="event-lesson-indicator" 
                title={lesson.event_name}
                style={{ background: eventColor }}
              >
                <EventIcon style={{ fontSize: "12px" }} />
                <span>{lesson.event_name}</span>
              </div>
            )}
            <div className={isEventLesson ? "event-lesson-content" : ""}>
              <span
                className={`lesson-type-block padding-5px-tb padding-15px-lr border-radius-5 margin-10px-bottom text-white font-size16 xs-font-size13 ${
                  isPast
                    ? "past-lesson"
                    : isSignUpDisabled
                    ? "sign-up-disabled"
                    : isFull
                    ? "full-lesson"
                    : "clickable"
                }`}
                style={getLessonTypeStyle(lesson.lesson_type.bg_color)}
                data-testid={`lesson-${lesson.lesson_id}`}
                onClick={() => {
                  if (!isPast && !isSignUpDisabled) {
                    handleOpenSignUpModal(lesson);
                  }
                }}
              >
                {lesson.lesson_type.friendly_name}
                {lesson.lesson_type.participants_per_booking >= 2 && (
                  <span className="duo-trio-indicator" title={lesson.lesson_type.spot_price != null ? "Cała rezerwacja lub pojedyncze miejsca" : `Rezerwacja całych zajęć dla ${lesson.lesson_type.participants_per_booking} osób`}>
                    {lesson.lesson_type.participants_per_booking === 2 ? " DUO" : " TRIO"}
                  </span>
                )}
                {lesson.payment_only_online && !lesson.lesson_type.is_free && (
                  <span className="online-only-indicator" title="Płatność tylko online">
                    💳
                  </span>
                )}
              </span>
              <div className="margin-10px-top font-size14">
                {start} - {end}
              </div>
              {lesson.trainer && (
                <div className="lesson-trainer-name font-size12">
                  👤 {lesson.trainer}
                </div>
              )}
              <div
                data-testid={`lesson-${lesson.lesson_id}-slots`}
                className="font-size13"
              >
                <BatteryIndicator
                  currentPeople={currentPeople}
                  maxPeople={maxPeople}
                />
                {lesson.waitlist_count > 0 && (
                  <div className="waitlist-indicator font-size12" title="Lista oczekujących">
                    ⏳ {lesson.waitlist_count}
                  </div>
                )}
              </div>
              {isPast && (
                <div className="past-lesson-text">
                  Zajęcia się odbyły
                </div>
              )}
              {isSignUpDisabled && (
                <div className="sign-up-disabled-text">
                  🔒 Zapisy wyłączone
                </div>
              )}
            </div>
          </div>
        );
      });

      timeSlots.push(
        <td key={`lesson-group-${i}`} className="lesson-group-cell" rowSpan={1}>
          {lessonGroup}
        </td>
      );
    } else {
      timeSlots.push(<td key={`empty-${i}`} className="bg-light-gray" />);
    }
  }

  return <tr>{timeSlots}</tr>;
};

export default SingleHour;
